<template>
  <div id="admin-variant-character-group-header">
    <el-row id="search-conditions-form">
      <el-form label-width="135px">
        <el-form-item label="書体">
          <el-select v-model="visibleFont">
            <el-option value="手彫り風書体">手彫り風書体</el-option>
            <el-option value="楷書体">楷書体</el-option>
            <el-option value="合掌体">機械書</el-option>
            <el-option value="手書き">手書き</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="検索用文字・部首">
          <div class="Inputs">
            <HandwritingInput1Char
              v-for="(item, index) in [1, 2, 3, 4, 5]"
              :key="index"
              :value="searchCharacters[index]"
              @onChangeInput="onChange($event, index)"
              @onSubmit="onChange($event, index)"
            />
          </div>
          <div class="InputErrorMessage" v-if="inputErrorVisible">
            {{ inputErrorMessage }}
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search(filterConditions)"
            >検索</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
  </div>
</template>

<script>
import HandwritingInput1Char from "@/components/HandwritingInput1Char";
export default {
  components: {
    HandwritingInput1Char,
  },
  data () {
    return {
      visibleFont: "手彫り風書体",
      searchCharacters: ["", "", "", "", ""],
      inputErrorMessage: "文字を入力してください",
      inputErrorVisible: false,
    };
  },
  computed: {
    /**
     * 楷書体は標準書体に変換
     */
    font: function () {
      return this.visibleFont === "楷書体" ? "標準書体" : this.visibleFont;
    },
    /**
     * @return {Array.<string>}
     */
    searchConditions: function () {
      return this.searchCharacters.filter(searchCharacter => {
        return (
          searchCharacter !== undefined &&
          searchCharacter !== null &&
          searchCharacter !== ""
        );
      });
    },

    /**
     * @return {object}
     */
    filterConditions: function () {
      return {
        font: this.font,
        searchConditions: this.searchConditions, // computed.searchConditions
      };
    },
  },
  methods: {
    /**
     * @param {object} filterConditions
     */
    search (filterConditions) {
      this.inputErrorVisible = !(
        this.searchCharacters[0] !== "" ||
        this.searchCharacters[1] !== "" ||
        this.searchCharacters[2] !== "" ||
        this.searchCharacters[3] !== "" ||
        this.searchCharacters[4] !== ""
      );
      this.$emit("onSearchVariantCharacterGroup", {
        q: filterConditions,
      });
    },
    onChange (value, index) {
      const updated = [...this.searchCharacters];
      updated[index] = value;
      this.searchCharacters = updated;
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/variables.scss";

#admin-variant-character-group-header {
  background: $background-gray-light;
}
#admin-variant-character-group-header #search-conditions-form {
  padding: 22px 20px;
  padding-bottom: 0px;
}
#admin-variant-character-group-header
  #search-conditions-form
  .search-character-input {
  margin-right: 5px;
  width: 50px;
}
.Inputs {
  display: flex;
}
.Inputs > * + * {
  margin-left: 20px;
}
.InputErrorMessage {
  color: red;
}
</style>
